export type NotificationType = 'INFO' | 'WARNING' | 'ERROR' | 'SUCCESS';

export interface VsysNotification {
  id: string;
  title: string;
  description: string;
  type: NotificationType;
  createdAt: Date | string;
  isRead: boolean;
  link?: string;
}

export function useNotifications() {
  return { 
     isConnected: false, 
     notifications: [] as VsysNotification[], 
     unreadCount: 0, 
     markAsRead: (id: string) => {}, 
     markAllAsRead: () => {} 
  };
}
